import {createFeatureSelector, createSelector} from '@ngrx/store';
import {BackgroundTaskState} from './background-task.state';
import {BackgroundTaskStatus} from './background-task.model';

export const selectBackgroundTaskState = createFeatureSelector<BackgroundTaskState>('backgroundTask');

export const selectPendingTasks = createSelector(
  selectBackgroundTaskState,
  (state) => state.pendingTasks
);

export const selectPendingTaskCount = createSelector(
  selectPendingTasks,
  (tasks) => tasks.length
);

export const selectHasPendingTasks = createSelector(
  selectPendingTaskCount,
  (count) => count > 0
);

export const selectRunningTasks = createSelector(
  selectPendingTasks,
  (tasks) => tasks.filter(t => t.status === BackgroundTaskStatus.Running)
);

export const selectAllTasks = createSelector(
  selectBackgroundTaskState,
  (state) => state.allTasks
);

export const selectCompletedNotifications = createSelector(
  selectBackgroundTaskState,
  (state) => state.completedNotifications
);

export const selectIsLoading = createSelector(
  selectBackgroundTaskState,
  (state) => state.isLoading
);

export const BackgroundTaskSelectors = {
  selectPendingTasks,
  selectPendingTaskCount,
  selectHasPendingTasks,
  selectRunningTasks,
  selectAllTasks,
  selectCompletedNotifications,
  selectIsLoading
};
